import { Component, Input, OnInit, Type, ViewEncapsulation } from '@angular/core';
import { ReelsData, ReelVideo, TrackingParameters } from '../reels-models';
import { SliderProOptions } from '../../slider-pro/slider-pro.component';
import { AbstractComponent } from '../../abstract.component';
import { ScreenType } from 'projects/common/model/ScreenType';
import { ReelItemComponent } from '../reel-item/reel-item.component';
import { Module } from '../../../model/ModuleModel';

@Component({
  selector: 'reels-slider',
  template: `
    <slider-pro
      [options]="sliderProOptions"
      [componentParams]="componentParams"
      [components]="components"
      [upaData]="rawUpaData">
    </slider-pro>
  `,
  styleUrls: ['./reels-slider.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReelsSliderComponent extends AbstractComponent implements OnInit {
  private static MODULE_ID = 'ReelsSliderModule';

  @Input() override module: Module<ReelsData>;
  @Input() trackingParams: TrackingParameters;

  sliderProOptions: SliderProOptions;
  rawUpaData: any;
  componentParams: any[];
  components: Type<any>[];

  getModuleId(): string {
    return ReelsSliderComponent.MODULE_ID;
  }

  ngOnInit(): void {
    this.initializeComponentParams();
    this.initializeSliderOptions();
    this.initializeRawUpaData();
    this.initializeComponentsArray();
  }

  private initializeComponentParams(): void {
    const { videos } = this.module.data;

    this.componentParams = videos.map((video: ReelVideo, index: number) => ({
      uniqueId: this.module.unique_id,
      reelItem: video,
      url: this.module.data.url,
      trackingParams: this.trackingParams,
      positionIndex: index
    }));
  }

  private initializeComponentsArray(): void {
    const length = this.module.data.videos.length;
    this.components = Array(length).fill(ReelItemComponent);
  }

  private initializeRawUpaData(): void {
    this.rawUpaData = {
      uniqueId: this.module.unique_id,
      moduleId: this.module.id,
      moduleIndex: this.module.row_number
    };
  }

  private initializeSliderOptions(): void {
    const isDesktop = this.screenType === ScreenType.DESKTOP;

    this.sliderProOptions = {
      itemsToShow: { DEFAULT: isDesktop ? 6 : 3 },
      itemsToMove: { DEFAULT: 1 },
      fixedWidth: { DEFAULT: 128 },
      dragToMove: { DEFAULT: !isDesktop },
      showArrows: { DEFAULT: isDesktop },
      showDots: { DEFAULT: true },
      dotsLighten: false,
      arrowsInnerContainer: false
    };
  }

}
